<template>
  <div
    class="HTML_BAR_INDICATOR_ITEM workspace_theme"
    ref="workspace_theme"
    :class="[sizeClassName, draggableStatus]"
  >
    <img
      v-if="fileData.posterBgImageUrlBase64"
      class="workspace_theme_bg"
      :src="fileData.posterBgImageUrlBase64"
    />

    <template v-if="fileData.fileList && fileData.fileList.length > 0">
      <span
        class="picContainer"
        v-for="picItem in fileData.fileList"
        :key="picItem.uid"
        :class="[
          picItem.className,
          picItem.actState,
          picItem.isShowPic ? '' : 'displayNone',
        ]"
        :style="picItem.styleItem"
      >
        <DraggableImageItem
          :currThemeObj="currThemeObj"
          :picItem="picItem"
          :cssDynamicObj="cssDynamicObj"
        ></DraggableImageItem>
      </span>
    </template>

    <span class="inputTextBg" v-if="[9].includes(sourceData.posterId)"></span>

    <img
      v-if="fileData.posterLImageUrlBase64"
      class="workspace_theme_bg posterLImage"
      :src="fileData.posterLImageUrlBase64"
    />

    <span class="titleName" v-text="fileData.titleName"></span>
    <span
      class="renderDataDom"
      :class="[7, 8, 9].includes(sourceData.posterId) ? 'inputText' : ''"
    >
      <template
        v-if="
          renderList &&
          renderList.length > 0 &&
          [1, 2, 3, 4, 5, 6].includes(sourceData.posterId)
        "
      >
        <span
          class="rowItem triangleContainer"
          v-for="item in renderList"
          :key="item.key"
        >
          <i class="triangle_left"></i>
          <i class="triangle_right"></i>
          <span class="rowItemBg triangleMain">
            <template v-if="sizeClassName.includes('singlePlayer')">
              <span class="barTitleArea">
                <span class="triangleContainer barTitle">
                  <i class="triangle_left"></i>
                  <i class="triangle_right"></i>
                  <span
                    class="triangleMain barTitleText"
                    :class="
                      item.name && item.name.length > 7 ? 'smallFont' : ''
                    "
                    v-text="item.name"
                  ></span>
                </span>
              </span>
              <span class="barValStr" v-text="item.value"></span>
            </template>
            <template v-else-if="sizeClassName.includes('doublePlayer')">
              <span class="barValStr" v-text="item.homeVal"></span>
              <span class="barTitleArea">
                <span class="triangleContainer barTitle">
                  <i class="triangle_left"></i>
                  <i class="triangle_right"></i>
                  <span
                    class="triangleMain barTitleText"
                    :class="
                      item.name && item.name.length > 7 ? 'smallFont' : ''
                    "
                    v-text="item.name"
                  ></span>
                </span>
              </span>
              <span class="barValStr" v-text="item.awayVal"></span>
            </template>
          </span>
        </span>
      </template>
      <template
        v-else-if="
          renderList &&
          renderList.length > 0 &&
          [7, 8, 9].includes(sourceData.posterId)
        "
      >
        <span
          class="rowItem triangleContainer"
          v-for="item in renderList"
          :key="item.key"
        >
          <i class="triangle_left"></i>
          <i class="triangle_right"></i>
          <span class="rowItemBg triangleMain">
            <template v-if="sizeClassName.includes('singlePlayer')">
              <span class="barTitleArea">
                <span class="triangleContainer barTitle">
                  <i class="triangle_left"></i>
                  <i class="triangle_right"></i>
                  <!-- <span
                    class="triangleMain barTitleText"
                    v-text="item.name"
                  ></span> -->
                  <span
                    class="triangleMain barTitleText"
                    :class="
                      item.name && item.name.length > 5 ? 'smallFont' : ''
                    "
                  >
                    <template v-if="isEditFlag">
                      <el-input
                        placeholder="运动员姓名"
                        v-model="item.name"
                      ></el-input>
                    </template>
                    <template v-else>
                      <span class="textSection" v-text="item.name"></span>
                    </template>
                  </span>
                </span>
              </span>
              <span class="barValStr inputRow">
                <template v-if="isEditFlag">
                  <el-input
                    placeholder="请输入内容"
                    v-model="item.value"
                  ></el-input>
                </template>
                <template v-else>
                  <span class="textSection" v-text="item.value"></span>
                </template>
              </span>
            </template>
            <!-- <template v-else-if="sizeClassName.includes('doublePlayer')">
              <span class="barValStr" v-text="item.homeVal"></span>
              <span class="barTitleArea">
                <span class="triangleContainer barTitle">
                  <i class="triangle_left"></i>
                  <i class="triangle_right"></i>
                  <span
                    class="triangleMain barTitleText"
                    v-text="item.name"
                  ></span>
                </span>
              </span>
              <span class="barValStr" v-text="item.awayVal"></span>
            </template> -->
          </span>
        </span>
        <span class="textArea">
          <template v-if="isEditFlag">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              :autosize="{ minRows: 3 }"
              v-model="textAreaStr"
              @change="textAreaChange"
            ></el-input>
          </template>
          <template v-else>
            <span
              class="textSection"
              v-for="(text, index) in textSectionList"
              :key="index"
              v-text="text"
            ></span>
          </template>
        </span>
      </template>
    </span>
  </div>
</template>
<script>
// 数据海报中的 指标项主题
import dataPoster_themeItem_comBase_mixin from '@mixins/dataPoster_themeItem_comBase'
export default {
  name: 'HTML_BAR_INDICATOR_ITEM',
  mixins: [dataPoster_themeItem_comBase_mixin],
  data() {
    return {
      textSectionList: [],
      textAreaStr: '',
    }
  },
  methods: {
    makePosterIdDatas(posterId, renderData) {
      let renderList = []
      if ([1, 2, 3].includes(posterId)) {
        // 单人
        console.debug('单人技术统计')
        const dataItem =
          renderData.data &&
          renderData.data.dataList &&
          renderData.data.dataList.length > 0
            ? renderData.data.dataList[0]
            : {}
        renderList = renderData.statisticsModels.map((keyItem, keyIndex) => {
          return {
            key: `${keyItem.statisticalEn}_${keyIndex}`,
            name: keyItem.name,
            value: this._valFormatHandler(
              dataItem[keyItem.statisticalEn],
              '-',
              keyItem.suffix
            ),
          }
        })
      } else if ([4, 5, 6].includes(posterId)) {
        // 双人
        console.debug('双人技术统计')
        const dataList =
          renderData.data && renderData.data.dataList
            ? renderData.data.dataList
            : [{}, {}]
        const home = dataList[0] ? dataList[0] : {}
        const away = dataList[1] ? dataList[1] : {}
        renderList = renderData.statisticsModels.map((keyItem) => {
          return {
            key: keyItem.statisticalEn,
            name: keyItem.name,
            homeVal: this._valFormatHandler(
              home[keyItem.statisticalEn],
              '-',
              keyItem.suffix
            ),
            awayVal: this._valFormatHandler(
              away[keyItem.statisticalEn],
              '-',
              keyItem.suffix
            ),
          }
        })
      } else if ([7, 8, 9].includes(posterId)) {
        const playerList =
          renderData.objectInfo &&
          renderData.objectInfo.length > 0 &&
          renderData.objectInfo[0].playerInfos
            ? renderData.objectInfo[0].playerInfos
            : []
        renderList = [
          {
            key: 'playerName',
            // name: playerList[0] ? playerList[0].playerName : '运动员姓名',
            name: '运动员姓名',
            value: '可编辑输入框区域',
            textSectionList: [
              '可编辑输入框区域',
              '点击左上角编辑按钮，即可开启海报中的可编辑输入框',
            ],
          },
        ]
        const textSectionList = renderList[0].textSectionList
        this.textAreaStr = textSectionList.join('\n')
        this.textSectionList = textSectionList
      }
      return renderList
    },
    textAreaChange(val) {
      console.debug({ input: val })
      this.textSectionList = val.split('\n')
    },
  },
}
</script>
<style lang="scss" scoped>
.HTML_BAR_INDICATOR_ITEM {
  &.workspace_theme {
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: left top;
    &.touchmove_open {
      .picContainer {
        pointer-events: none;
        &.click {
          pointer-events: all;
        }
      }
    }
    .workspace_theme_bg {
      position: relative;
      display: block;
      width: 100%;
      height: 100%;
      pointer-events: none;
    }
    .posterLImage {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 120;
      width: 100;
      height: 100%;
    }
    .picContainer {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      /* left: 30%;
          top: 0; */
      z-index: 100;
      overflow: hidden;
      cursor: move !important;
      &:hover {
        cursor: move !important;
      }
      &.displayNone {
        display: none;
      }
      &.click {
        .imageSpan {
          &::before {
            border: 1px solid var(--mixtmt_mainColor);
          }
        }
      }
      &.longPress {
        .imageSpan {
          /* opacity: 0.6; */
          &::before {
            background-color: var(--mixtmt_greyColor5);
            border: 1px solid var(--mixtmt_subColor1_1);
          }
        }
      }
      .imageSpan {
        position: relative;
        img {
          display: block;
          width: 100%;
          height: 100%;
          /* object-fit: contain; */
        }
        .img {
          display: block;
          width: 100%;
          height: 100%;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }
        &::before {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          content: '\20';
          pointer-events: none;
          width: 100%;
          height: 100%;
          border: 0;
        }
      }
    }
    &.horizontalScreen {
      /* 横版 */
      &.singlePlayer {
        .renderDataDom {
          left: 25.94%;
          width: 49.32%;
          .rowItem {
            .rowItemBg {
              .barTitleArea {
                width: 48%;
                .barTitle {
                  .barTitleText {
                    &.smallFont {
                      font-size: calc(1.8vw * var(--mixtmt_dataPoster_mixvw));
                    }
                    & {
                      font-size: calc(2.4vw * var(--mixtmt_dataPoster_mixvw));
                    }
                  }
                }
              }
              .barValStr {
                width: 52%;
                font-size: calc(2.2vw * var(--mixtmt_dataPoster_mixvw));
              }
            }
          }
        }
      }
      &.doublePlayer {
        .renderDataDom {
          left: 35.26%;
          width: 44.792%;
          .rowItem {
            .rowItemBg {
              .barTitleArea {
                width: 42%;
                .barTitle {
                  .barTitleText {
                    &.smallFont {
                      font-size: calc(1.4vw * var(--mixtmt_dataPoster_mixvw));
                    }
                    & {
                      font-size: calc(1.8vw * var(--mixtmt_dataPoster_mixvw));
                    }
                  }
                }
              }
              .barValStr {
                width: 26%;
                font-size: calc(1.6vw * var(--mixtmt_dataPoster_mixvw));
              }
            }
          }
        }
      }
      .renderDataDom {
        top: 6.48%;
        height: calc(100% - 6.48% - 6.48% - 18.7%);
        &.inputText {
          top: 0;
          left: 47.666%;
          width: 52.344%;
          height: 81.3%;
          justify-content: flex-start;
          background-color: var(--mixtmt_dataPoster_textAreaBgColor);
          .rowItem {
            margin: calc(3.888vw * var(--mixtmt_dataPoster_mixvw))
              calc(6vw * var(--mixtmt_dataPoster_mixvw));
            height: calc(2.865vw * var(--mixtmt_dataPoster_mixvw));
            width: calc(100% - 20vw * var(--mixtmt_dataPoster_mixvw));
            .triangle_left {
              &::before {
                border-right: calc(1.25vw * var(--mixtmt_dataPoster_mixvw))
                  solid var(--mixtmt_dataPoster_barMainColorBg);
              }
            }
            .triangle_right {
              &::before {
                border-left: calc(1.25vw * var(--mixtmt_dataPoster_mixvw)) solid
                  var(--mixtmt_dataPoster_barMainColorBg);
              }
            }

            .rowItemBg {
              .barTitleArea {
                width: 44%;
                .barTitle {
                  width: calc(
                    100% - 2 * (1.25vw * var(--mixtmt_dataPoster_mixvw))
                  );
                  margin: 0 calc(1.25vw * var(--mixtmt_dataPoster_mixvw));
                  height: calc(2.865vw * var(--mixtmt_dataPoster_mixvw));
                  .barTitleText {
                    &.smallFont {
                      font-size: calc(1.4vw * var(--mixtmt_dataPoster_mixvw));
                    }
                    & {
                      position: relative;
                      font-size: calc(1.8vw * var(--mixtmt_dataPoster_mixvw));
                    }
                  }
                  .triangle_left {
                    &::before {
                      border-right: calc(
                          1.25vw * var(--mixtmt_dataPoster_mixvw)
                        )
                        solid var(--mixtmt_dataPoster_barSubColorBg);
                    }
                  }
                  .triangle_right {
                    &::before {
                      border-left: calc(1.25vw * var(--mixtmt_dataPoster_mixvw))
                        solid var(--mixtmt_dataPoster_barSubColorBg);
                    }
                  }
                }
              }
              .barValStr {
                &.inputRow {
                  width: 56%;
                  position: relative;
                }
                & {
                  font-size: calc(1.8vw * var(--mixtmt_dataPoster_mixvw));
                }
              }
            }
            .textSection {
              position: absolute;
              left: 0;
              top: 0;
              z-index: 2;
              width: 100%;
              height: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: center;
              align-items: center;
            }
          }
          .triangleContainer {
            .triangle_left,
            .triangle_right {
              width: calc(1.25vw * var(--mixtmt_dataPoster_mixvw));
              height: calc(2.865vw * var(--mixtmt_dataPoster_mixvw));
              &::before {
                border-top: calc(1.5vw * var(--mixtmt_dataPoster_mixvw)) solid
                  transparent;
                border-bottom: calc(1.5vw * var(--mixtmt_dataPoster_mixvw))
                  solid transparent;
              }
            }
          }
          .textArea {
            width: 100%;
          }
        }
        .rowItem {
          margin: calc(0.9375vw * var(--mixtmt_dataPoster_mixvw))
            calc(2vw * var(--mixtmt_dataPoster_mixvw));
          height: calc(3.906vw * var(--mixtmt_dataPoster_mixvw));
          .triangle_left {
            &::before {
              border-right: calc(1.666vw * var(--mixtmt_dataPoster_mixvw)) solid
                var(--mixtmt_dataPoster_barMainColorBg);
            }
          }
          .triangle_right {
            &::before {
              border-left: calc(1.666vw * var(--mixtmt_dataPoster_mixvw)) solid
                var(--mixtmt_dataPoster_barMainColorBg);
            }
          }
          .rowItemBg {
            .barTitleArea {
              margin-left: calc(-0.5vw * var(--mixtmt_dataPoster_mixvw));
              .barTitle {
                height: calc(3.906vw * var(--mixtmt_dataPoster_mixvw));
                .triangle_left {
                  &::before {
                    border-right: calc(1.666vw * var(--mixtmt_dataPoster_mixvw))
                      solid var(--mixtmt_dataPoster_barSubColorBg);
                  }
                }
                .triangle_right {
                  &::before {
                    border-left: calc(1.666vw * var(--mixtmt_dataPoster_mixvw))
                      solid var(--mixtmt_dataPoster_barSubColorBg);
                  }
                }
              }
            }
          }
        }
      }
      .triangleContainer {
        width: calc(100% - 2 * (1.666vw * var(--mixtmt_dataPoster_mixvw)));
        margin: 0 calc(1.666vw * var(--mixtmt_dataPoster_mixvw));
        .triangle_left,
        .triangle_right {
          width: calc(1.666vw * var(--mixtmt_dataPoster_mixvw));
          height: calc(3.906vw * var(--mixtmt_dataPoster_mixvw));
          &::before {
            border-top: calc(2vw * var(--mixtmt_dataPoster_mixvw)) solid
              transparent;
            border-bottom: calc(2vw * var(--mixtmt_dataPoster_mixvw)) solid
              transparent;
          }
        }
      }
      .titleName {
        left: calc(10.104vw * var(--mixtmt_dataPoster_mixvw));
        top: 0;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: calc(7.76vw * var(--mixtmt_dataPoster_mixvw));
        height: 67.41%;
        font-size: calc(4.896vw * var(--mixtmt_dataPoster_mixvw));
        line-height: calc(5.6vw * var(--mixtmt_dataPoster_mixvw));
        color: var(--mixtmt_dataPoster_titleNameColor);
        /* font-weight: bold; */
        text-align: center;
      }
    }
    &.verticalScreen {
      /* 竖版 */
      &.singlePlayer {
        .renderDataDom {
          .rowItem {
            .rowItemBg {
              .barTitleArea {
                width: 48%;
                .barTitle {
                  .barTitleText {
                    &.smallFont {
                      font-size: calc(2.8vw * var(--mixtmt_dataPoster_mixvw));
                    }
                    & {
                      font-size: calc(3.704vw * var(--mixtmt_dataPoster_mixvw));
                    }
                  }
                }
              }
              .barValStr {
                width: 52%;
                font-size: calc(3.4vw * var(--mixtmt_dataPoster_mixvw));
              }
            }
          }
        }
      }
      &.doublePlayer {
        .renderDataDom {
          .rowItem {
            .rowItemBg {
              .barTitleArea {
                width: 40%;
                .barTitle {
                  .barTitleText {
                    &.smallFont {
                      font-size: calc(2.3vw * var(--mixtmt_dataPoster_mixvw));
                    }
                    & {
                      font-size: calc(3.2vw * var(--mixtmt_dataPoster_mixvw));
                    }
                  }
                }
              }
              .barValStr {
                width: 30%;
                font-size: calc(2.8vw * var(--mixtmt_dataPoster_mixvw));
              }
            }
          }
        }
      }
      .renderDataDom {
        left: 5.56%;
        top: 44.54%;
        width: 78.24%;
        height: 46.62%;
        &.inputText {
          top: 52%;
          left: 0;
          width: calc(100% - 10.648%);
          height: 48%;
          justify-content: flex-start;
          background-color: var(--mixtmt_dataPoster_textAreaBgColor);
          .rowItem {
            margin: calc(3.888vw * var(--mixtmt_dataPoster_mixvw))
              calc(14vw * var(--mixtmt_dataPoster_mixvw));
            height: calc(5.185vw * var(--mixtmt_dataPoster_mixvw));
            width: calc(100% - 28vw * var(--mixtmt_dataPoster_mixvw));
            .triangle_left {
              &::before {
                border-right: calc(2.22vw * var(--mixtmt_dataPoster_mixvw))
                  solid var(--mixtmt_dataPoster_barMainColorBg);
              }
            }
            .triangle_right {
              &::before {
                border-left: calc(2.22vw * var(--mixtmt_dataPoster_mixvw)) solid
                  var(--mixtmt_dataPoster_barMainColorBg);
              }
            }

            .rowItemBg {
              .barTitleArea {
                width: 44%;
                .barTitle {
                  width: calc(
                    100% - 2 * (2.22vw * var(--mixtmt_dataPoster_mixvw))
                  );
                  margin: 0 calc(2.22vw * var(--mixtmt_dataPoster_mixvw));
                  height: calc(5.185vw * var(--mixtmt_dataPoster_mixvw));
                  .barTitleText {
                    &.smallFont {
                      font-size: calc(2.8vw * var(--mixtmt_dataPoster_mixvw));
                    }
                    & {
                      position: relative;
                      font-size: calc(3.5vw * var(--mixtmt_dataPoster_mixvw));
                    }
                  }
                  .triangle_left {
                    &::before {
                      border-right: calc(
                          2.22vw * var(--mixtmt_dataPoster_mixvw)
                        )
                        solid var(--mixtmt_dataPoster_barSubColorBg);
                    }
                  }
                  .triangle_right {
                    &::before {
                      border-left: calc(2.22vw * var(--mixtmt_dataPoster_mixvw))
                        solid var(--mixtmt_dataPoster_barSubColorBg);
                    }
                  }
                }
              }
              .barValStr {
                &.inputRow {
                  width: 56%;
                  position: relative;
                  /* .textSection {
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 2;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    display: -webkit-flex;
                    justify-content: center;
                    align-items: center;
                  } */
                }
                & {
                  font-size: calc(3.5vw * var(--mixtmt_dataPoster_mixvw));
                }
              }
            }
          }
          .triangleContainer {
            .triangle_left,
            .triangle_right {
              width: calc(2.22vw * var(--mixtmt_dataPoster_mixvw));
              height: calc(5.185vw * var(--mixtmt_dataPoster_mixvw));
              &::before {
                border-top: calc(2.925vw * var(--mixtmt_dataPoster_mixvw)) solid
                  transparent;
                border-bottom: calc(2.925vw * var(--mixtmt_dataPoster_mixvw))
                  solid transparent;
              }
            }
          }
          .textArea {
            width: 100%;
          }
        }
        .rowItem {
          margin: calc(1.62vw * var(--mixtmt_dataPoster_mixvw))
            calc(3vw * var(--mixtmt_dataPoster_mixvw));
          height: calc(6.481vw * var(--mixtmt_dataPoster_mixvw));
          .triangle_left {
            &::before {
              border-right: calc(2.778vw * var(--mixtmt_dataPoster_mixvw)) solid
                var(--mixtmt_dataPoster_barMainColorBg);
            }
          }
          .triangle_right {
            &::before {
              border-left: calc(2.778vw * var(--mixtmt_dataPoster_mixvw)) solid
                var(--mixtmt_dataPoster_barMainColorBg);
            }
          }
          .rowItemBg {
            .barTitleArea {
              margin-left: calc(-0.5vw * var(--mixtmt_dataPoster_mixvw));
              .barTitle {
                height: calc(6.481vw * var(--mixtmt_dataPoster_mixvw));
                .triangle_left {
                  &::before {
                    border-right: calc(2.778vw * var(--mixtmt_dataPoster_mixvw))
                      solid var(--mixtmt_dataPoster_barSubColorBg);
                  }
                }
                .triangle_right {
                  &::before {
                    border-left: calc(2.778vw * var(--mixtmt_dataPoster_mixvw))
                      solid var(--mixtmt_dataPoster_barSubColorBg);
                  }
                }
              }
            }
          }
        }
      }
      .triangleContainer {
        width: calc(100% - 2 * (2.778vw * var(--mixtmt_dataPoster_mixvw)));
        margin: 0 calc(2.778vw * var(--mixtmt_dataPoster_mixvw));
        .triangle_left,
        .triangle_right {
          width: calc(2.778vw * var(--mixtmt_dataPoster_mixvw));
          height: calc(6.481vw * var(--mixtmt_dataPoster_mixvw));
          &::before {
            border-top: calc(3.65vw * var(--mixtmt_dataPoster_mixvw)) solid
              transparent;
            border-bottom: calc(3.65vw * var(--mixtmt_dataPoster_mixvw)) solid
              transparent;
          }
        }
      }
      .titleName {
        left: 0;
        top: 10.8715%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 89.26%;
        padding: 0 5%;
        height: 5.436%;
        font-size: calc(5.926vw * var(--mixtmt_dataPoster_mixvw));
        color: var(--mixtmt_dataPoster_titleNameColor);
        /* font-weight: bold; */
        text-align: center;
        letter-spacing: calc(0.5vw * var(--mixtmt_dataPoster_mixvw));
      }
    }
    &.squareScreen {
      /* 方版 */
      &.singlePlayer {
        .renderDataDom {
          .rowItem {
            .rowItemBg {
              .barTitleArea {
                width: 40%;
                .barTitle {
                  .barTitleText {
                    &.smallFont {
                      font-size: calc(2.3vw * var(--mixtmt_dataPoster_mixvw));
                    }
                    & {
                      font-size: calc(2.667vw * var(--mixtmt_dataPoster_mixvw));
                    }
                  }
                }
              }
              .barValStr {
                width: 60%;
                font-size: calc(2.866vw * var(--mixtmt_dataPoster_mixvw));
              }
            }
          }
        }
      }
      &.doublePlayer {
        .renderDataDom {
          .rowItem {
            .rowItemBg {
              .barTitleArea {
                width: 40%;
                .barTitle {
                  .barTitleText {
                    &.smallFont {
                      font-size: calc(2.3vw * var(--mixtmt_dataPoster_mixvw));
                    }
                    & {
                      font-size: calc(2.8vw * var(--mixtmt_dataPoster_mixvw));
                    }
                  }
                }
              }
              .barValStr {
                width: 30%;
                font-size: calc(2.8vw * var(--mixtmt_dataPoster_mixvw));
              }
            }
          }
        }
      }
      .renderDataDom {
        left: 16.13%;
        top: 50.3125%;
        width: 72.5%;
        height: 43.4375%;
        &.inputText {
          justify-content: flex-start;
          left: 10.13%;
          top: 22%;
          width: 89.83%;
          height: 77%;
          .rowItem {
            margin: calc(3.888vw * var(--mixtmt_dataPoster_mixvw))
              calc(23vw * var(--mixtmt_dataPoster_mixvw));
            height: calc(4.8vw * var(--mixtmt_dataPoster_mixvw));
            width: calc(100% - 46vw * var(--mixtmt_dataPoster_mixvw));
            .triangle_left {
              &::before {
                border-right: calc(2vw * var(--mixtmt_dataPoster_mixvw)) solid
                  var(--mixtmt_dataPoster_barMainColorBg);
              }
            }
            .triangle_right {
              &::before {
                border-left: calc(2vw * var(--mixtmt_dataPoster_mixvw)) solid
                  var(--mixtmt_dataPoster_barMainColorBg);
              }
            }
            .rowItemBg {
              .barTitleArea {
                width: 44%;
                .barTitle {
                  width: calc(
                    100% - 2 * (2vw * var(--mixtmt_dataPoster_mixvw))
                  );
                  margin: 0 calc(2vw * var(--mixtmt_dataPoster_mixvw));
                  height: calc(4.8vw * var(--mixtmt_dataPoster_mixvw));
                  .barTitleText {
                    &.smallFont {
                      font-size: calc(1.9vw * var(--mixtmt_dataPoster_mixvw));
                    }
                    & {
                      position: relative;
                      font-size: calc(2.5vw * var(--mixtmt_dataPoster_mixvw));
                    }
                  }
                  .triangle_left {
                    &::before {
                      border-right: calc(2vw * var(--mixtmt_dataPoster_mixvw))
                        solid var(--mixtmt_dataPoster_barSubColorBg);
                    }
                  }
                  .triangle_right {
                    &::before {
                      border-left: calc(2vw * var(--mixtmt_dataPoster_mixvw))
                        solid var(--mixtmt_dataPoster_barSubColorBg);
                    }
                  }
                }
              }
              .barValStr {
                &.inputRow {
                  width: 56%;
                  position: relative;
                  /* .textSection {
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 2;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    display: -webkit-flex;
                    justify-content: center;
                    align-items: center;
                  } */
                }
                & {
                  font-size: calc(2.5vw * var(--mixtmt_dataPoster_mixvw));
                }
              }
            }
          }
          .triangleContainer {
            .triangle_left,
            .triangle_right {
              width: calc(2vw * var(--mixtmt_dataPoster_mixvw));
              height: calc(4.8vw * var(--mixtmt_dataPoster_mixvw));
              &::before {
                border-top: calc(2.465vw * var(--mixtmt_dataPoster_mixvw)) solid
                  transparent;
                border-bottom: calc(2.465vw * var(--mixtmt_dataPoster_mixvw))
                  solid transparent;
              }
            }
          }
          .textArea {
            width: 100%;
          }
        }
        .rowItem {
          margin: calc(1.11vw * var(--mixtmt_dataPoster_mixvw))
            calc(2vw * var(--mixtmt_dataPoster_mixvw));
          height: calc(5.6757vw * var(--mixtmt_dataPoster_mixvw));
          .triangle_left {
            &::before {
              border-right: calc(2.13vw * var(--mixtmt_dataPoster_mixvw)) solid
                var(--mixtmt_dataPoster_barMainColorBg);
            }
          }
          .triangle_right {
            &::before {
              border-left: calc(2.13vw * var(--mixtmt_dataPoster_mixvw)) solid
                var(--mixtmt_dataPoster_barMainColorBg);
            }
          }
          .rowItemBg {
            .barTitleArea {
              margin-left: calc(-0.5vw * var(--mixtmt_dataPoster_mixvw));
              .barTitle {
                height: calc(5.6757vw * var(--mixtmt_dataPoster_mixvw));
                .triangle_left {
                  &::before {
                    border-right: calc(2.13vw * var(--mixtmt_dataPoster_mixvw))
                      solid var(--mixtmt_dataPoster_barSubColorBg);
                  }
                }
                .triangle_right {
                  &::before {
                    border-left: calc(2.13vw * var(--mixtmt_dataPoster_mixvw))
                      solid var(--mixtmt_dataPoster_barSubColorBg);
                  }
                }
              }
            }
          }
        }
      }
      .triangleContainer {
        width: calc(100% - 2 * (2.13vw * var(--mixtmt_dataPoster_mixvw)));
        margin: 0 calc(2.13vw * var(--mixtmt_dataPoster_mixvw));
        .triangle_left,
        .triangle_right {
          width: calc(2.13vw * var(--mixtmt_dataPoster_mixvw));
          height: calc(5.6757vw * var(--mixtmt_dataPoster_mixvw));
          &::before {
            border-top: calc(2.94vw * var(--mixtmt_dataPoster_mixvw)) solid
              transparent;
            border-bottom: calc(2.94vw * var(--mixtmt_dataPoster_mixvw)) solid
              transparent;
          }
        }
      }
      .titleName {
        left: 10.4%;
        top: 13.125%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 89.6%;
        padding: 0 5%;
        height: 7.8125%;
        font-size: calc(4vw * var(--mixtmt_dataPoster_mixvw));
        color: var(--mixtmt_dataPoster_titleNameColor);
        /* font-weight: bold; */
        text-align: center;
        letter-spacing: calc(0.5vw * var(--mixtmt_dataPoster_mixvw));
      }
    }
    .inputTextBg {
      position: absolute;
      z-index: 110;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      left: 10.13%;
      top: 12%;
      width: 89.83%;
      height: 88%;
      background-color: var(--mixtmt_dataPoster_textAreaBgColor);
    }
    .renderDataDom {
      position: absolute;
      z-index: 150;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .rowItem {
        background-color: var(--mixtmt_dataPoster_barMainColorBg);
        .rowItemBg {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          background-color: var(--mixtmt_dataPoster_barMainColorBg);
          .barTitleArea {
            .barTitle {
              .barTitleText {
                display: flex;
                display: -webkit-flex;
                justify-content: center;
                align-items: center;
                /* font-weight: bold; */
                color: var(--mixtmt_dataPoster_barTitleTextColor);
                background-color: var(--mixtmt_dataPoster_barSubColorBg);
              }
            }
          }
          .barValStr {
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            flex: 1;
            color: var(--mixtmt_dataPoster_valueColor);
            /* font-weight: bold; */
          }
        }
      }
    }
    .triangleContainer {
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .triangle_left,
      .triangle_right {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 50%;
        z-index: 2;
        /* overflow: hidden; */
        &::before {
          content: '\20';
          width: 0;
          height: 0;
        }
      }
      .triangle_left {
        left: 0.5px;
        transform: translate(-100%, -50%);
      }
      .triangle_right {
        right: 0.5px;
        transform: translate(100%, -50%);
      }
      .triangleMain {
        position: relative;
        width: 100%;
        height: 100%;
      }
    }
    .titleName {
      position: absolute;
      z-index: 130;
      pointer-events: none;
    }
  }
}
</style>
<style lang="scss">
.HTML_BAR_INDICATOR_ITEM {
  &.horizontalScreen {
    .inputText {
      .inputRow,
      .barTitleText {
        .el-input__inner {
          font-size: calc(1.875vw * var(--mixtmt_dataPoster_mixvw));
          height: calc(2.865vw * var(--mixtmt_dataPoster_mixvw));
          line-height: calc(
            2.865vw * var(--mixtmt_dataPoster_mixvw) - 1px - 1px
          );
        }
      }
      .textArea {
        padding: calc(1vw * var(--mixtmt_dataPoster_mixvw))
          calc(2.912vw * var(--mixtmt_dataPoster_mixvw));
        textarea {
          font-size: calc(1.875vw * var(--mixtmt_dataPoster_mixvw));
          line-height: calc(2.2vw * var(--mixtmt_dataPoster_mixvw));
        }
        .textSection {
          font-size: calc(1.875vw * var(--mixtmt_dataPoster_mixvw));
          line-height: calc(2.2vw * var(--mixtmt_dataPoster_mixvw));
          text-indent: calc(2 * 1.875vw * var(--mixtmt_dataPoster_mixvw));
        }
      }
    }
  }
  &.verticalScreen {
    .inputText {
      .inputRow,
      .barTitleText {
        .el-input__inner {
          font-size: calc(3.5vw * var(--mixtmt_dataPoster_mixvw));
          height: calc(5.185vw * var(--mixtmt_dataPoster_mixvw));
          line-height: calc(
            5.185vw * var(--mixtmt_dataPoster_mixvw) - 1px - 1px
          );
        }
      }
      .textArea {
        padding: calc(1vw * var(--mixtmt_dataPoster_mixvw))
          calc(2.912vw * var(--mixtmt_dataPoster_mixvw));
        textarea {
          font-size: calc(3.5vw * var(--mixtmt_dataPoster_mixvw));
          line-height: calc(4vw * var(--mixtmt_dataPoster_mixvw));
        }
        .textSection {
          font-size: calc(3.5vw * var(--mixtmt_dataPoster_mixvw));
          line-height: calc(4vw * var(--mixtmt_dataPoster_mixvw));
          text-indent: calc(2 * 3.5vw * var(--mixtmt_dataPoster_mixvw));
        }
      }
    }
  }
  &.squareScreen {
    .inputText {
      .inputRow,
      .barTitleText {
        .el-input__inner {
          font-size: calc(2.5vw * var(--mixtmt_dataPoster_mixvw));
          height: calc(5.6757vw * var(--mixtmt_dataPoster_mixvw));
          line-height: calc(
            5.6757vw * var(--mixtmt_dataPoster_mixvw) - 1px - 1px
          );
        }
      }
      .textArea {
        padding: calc(1vw * var(--mixtmt_dataPoster_mixvw))
          calc(2.912vw * var(--mixtmt_dataPoster_mixvw));
        textarea {
          font-size: calc(2.5vw * var(--mixtmt_dataPoster_mixvw));
          line-height: calc(4vw * var(--mixtmt_dataPoster_mixvw));
        }
        .textSection {
          font-size: calc(2.5vw * var(--mixtmt_dataPoster_mixvw));
          line-height: calc(4vw * var(--mixtmt_dataPoster_mixvw));
          text-indent: calc(2 * 2.5vw * var(--mixtmt_dataPoster_mixvw));
        }
      }
    }
  }
  .inputText {
    .inputRow {
      height: 100%;
    }
    .inputRow,
    .barTitleText {
      .el-input {
        font-size: 0;
      }
      .el-input__inner {
        width: 100%;
        padding: 0;
        background-color: transparent;
        border: 0;
        text-align: center;
        color: var(--mixtmt_whiteColor);
        border-radius: 0;
      }
    }
    .textArea {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      textarea {
        width: 100%;
        padding: 0;
        resize: none;
        background-color: transparent;
        border: 0;
        color: var(--mixtmt_whiteColor);
        text-align: justify;
        border-radius: 0;
      }
      .textSection {
        width: 100%;
        color: var(--mixtmt_whiteColor);
        text-align: justify;
        white-space: normal;
      }
    }
  }
}
</style>
